import { ApiFormattedResponse } from "@models/api_formatted_response"
import { query } from "@utils/graphql"
import {
  MarketplaceOrdersPaginated,
  MarketplaceOrdersResponse,
  QueryGetMarketplaceOrdersArgs
} from "__generated__/graphql"
import getMarketplaceOrders from "__generated__/queries/queries/getMarketplaceOrders"

export async function getMarketplaceOrdersQuery(
  data: QueryGetMarketplaceOrdersArgs
): Promise<ApiFormattedResponse<MarketplaceOrdersPaginated>> {
  const response = await query<{
    getMarketplaceOrders?: MarketplaceOrdersResponse
  }>({
    query: getMarketplaceOrders,
    variables: data
  })
  if (!response.isSuccess) {
    return { ...response, data: undefined }
  }

  return {
    isSuccess: true,
    data: response.data?.getMarketplaceOrders
      ?.data as MarketplaceOrdersPaginated
  }
}
